import { render, staticRenderFns } from "./AgeAndHeight.vue?vue&type=template&id=fa26226a"
import script from "./AgeAndHeight.vue?vue&type=script&lang=js"
export * from "./AgeAndHeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports